import React from "react";
import Navbar from "../../components/shared/CustomNavbar";
import Footer from "../../components/shared/Footer";
import menuData from "../../utils/data/menu.json";
import Hero from "./components/Hero";
import Testimonial from "../../components/shared/Testimonial";
import Logo from "../../assets/svgs/logos/logo-white.svg";
import { BiLogoFacebook, BiLogoTwitter, BiLogoInstagram } from "react-icons/bi";
import { AiFillLinkedin } from "react-icons/ai";
import footerData from "../../utils/data/footer.json";
import LogoBlack from "../../assets/svgs/logos/logo-black.svg";

const socialLinks = [
  {
    url: "https://www.instagram.com/9ijakids",
    icon: <BiLogoInstagram className="cursor-pointer" />,
  },
  {
    url: "https://twitter.com/9ijakids?t=4YP8vgUSVJzw7KhpS9e_0Q&s=08",
    icon: <BiLogoTwitter className="cursor-pointer" />,
  },
  {
    url: "https://www.facebook.com/9ijakids",
    icon: <BiLogoFacebook className="cursor-pointer" />,
  },
  { url: "https://t.me/+B3jIp1KP4qE0MDk8", icon: <AiFillLinkedin /> },
];

const page = () => {
  const competitionLinks = menuData?.menuData.find(
    (data) => data.competition
  )?.competition;

  // Transform links to objects with 'name' and 'link' properties
  const data = footerData.footerData.map((section) => ({
    header: section.header,
    links: section.links.map((link) => ({
      name: link,
      link: link.toLowerCase().replace(/[^a-zA-Z0-9]/g, "-"),
    })),
  }));

  return (
    <div>
      <Navbar
        data={competitionLinks}
        bgColors="bg-deepBlue"
        textColor="text-white"
        outlineText="Help & Support"
        btnText="Log in"
        outlineTextLink="/help"
        btnTextLink="/login"
        logoLink="/"
        logoSrc={Logo}
        logoAlt="logo-image"
      />
      <Hero />
      <Testimonial bgColor="bg-[#F1F3F1]" />
      <Footer
        data={data}
        logoSrc={LogoBlack}
        logoAlt="quiz-logo"
        logoLink="/"
        logoTextColor="text-deepBlue"
        placeholderColor="placeholder-deepBlue"
        inputIconColor="text-deepBlue"
        hoverColor="hover:text-gray-600"
        socialLinks={socialLinks}
        bgColor="bg-deepBlue"
        textColor="text-white"
        subscribeText="Stay in touch with us for the freshest products!"
        disclaimerText="Qwizfun powered by 9ijakids"
      />
    </div>
  );
};

export default page;
